<template>
  <div>
    <div v-if="checkShowAPPDownloadBanner" class="app-download">
      <div style="font-size: 0.8rem; margin-right: -1.8rem" @click="hideDownloadAppBanner">
        <i class="bi bi-x"></i>
      </div>
      <div class="download-left">
        <img class="download-icon" :src="`${resBaseUrl}app-icon.png`" alt="" />
        <div class="download-desc">{{ $t('app.downloadapp') }}</div>
      </div>
      <div class="download-btn" @click="onDownLoadAPk">
        {{ $t('app.download') }}
      </div>
    </div>
    <div
      v-if="hasStickyBanner"
      class="sticky_banner"
      :style="checkShowAPPDownloadBanner ? 'top:0.8rem' : 'top: 0'"
    >
      <van-swipe :touchable="true" :autoplay="3000" class="swiper">
        <van-swipe-item
          @click="onClickBanner(banner)"
          v-for="(banner, i) in sticky_banners"
          :key="i"
          class="item"
          :style="`background-image: url(${banner.cover});`"
        >
          <!-- <img :src="banner.cover" class="img" alt="" /> -->
        </van-swipe-item>
      </van-swipe>
    </div>
    <div
      :class="`user-bar flex row between center`"
      :style="
        checkShowAPPDownloadBanner
          ? `${hasStickyBanner ? 'top: calc(0.8rem + 5.55vw);' : 'top: 0.8rem'}`
          : 'top: 0'
      "
    >
      <div class="left flex row center">
        <i
          v-if="
            $route.name !== 'RushDeposit' &&
            $route.name !== 'Million' &&
            $route.name !== 'VpsExchange'
          "
          class="bi-list"
          @click="onShowMenu"
        ></i>
        <i v-else class="bi bi-chevron-left" @click="$router.replace('/')"></i>
        <img v-if="country != 'GH'" src="https://res.megalake.games/lobby/logo-new.png" alt="logo" />
        <img v-else style="width: 2.2rem;height: auto;" src="https://res.megalake.games/lobby/logo_bigwins.png" alt="logo" />
      </div>
      <div class="right flex row center" :key="userBarKey" ref="balanceRef">
        <div v-if="isLogin" class="wallet flex row center" style="z-index: 99">
          <div class="balance" @click="showBalanceInfo">
            {{ formatMoney(balance.total) }} {{ unitConversion(balance.currencyAlias) }}
          </div>
          <div class="slicer"></div>
          <i @click="onDeposit" class="bi-plus-circle"></i>
        </div>
        <div v-if="!isLogin" class="login" @click="onOpenLogin">
          {{ $t('userBar.login') }}
        </div>
        <div v-if="!isLogin" class="register" @click="onOpenRegister">
          {{ $t('userBar.register') }}
        </div>
      </div>
    </div>
    <BalanceTips
      :show="showBalanceTips"
      :balanceWidth="balanceWidth"
      @hide="showBalanceTips = false"
    />
  </div>
</template>

<script>
import { validatePassword, validateUsername } from '@/common/valiadate.js'
import { useUserStore } from '@/stores/user.js'
import { mapActions, mapState } from 'pinia'
import { config } from '@/common/config'
import { getLocalStorage, Key } from '@/common/localStorage'
import BalanceTips from '@/components/BalanceTipsComponent.vue'
import { BUS, POPUP } from '@/event/EventCenter'
import { useEnvelopeStore } from '@/stores/envelope'
import { useLanguagesStore } from '@/stores/languages'
import { useLobbyStore } from '@/stores/lobby'
import {
  downloadAPK,
  encodeBase64,
  enterEnvelop,
  formatMoney,
  unitConversion
} from '@/utils/helper'

export default {
  components: { BalanceTips },
  data() {
    return {
      resBaseUrl: config.resBaseUrl,
      from: 'register',
      userBarKey: 0,
      showBalanceTips: false,
      balanceWidth: 0,
      sticky_banners: []
    }
  },
  computed: {
    ...mapState(useUserStore, ['country', 'isLogin', 'balance']),
    ...mapState(useLanguagesStore, ['languages']),
    ...mapState(useLobbyStore, ['hasStickyBanner', 'checkShowAPPDownloadBanner'])
  },
  mounted() {
    this.getBannersHomeTop('sticky_banner').then((r) => {
      console.log('吸顶banner', r.banners)
      this.sticky_banners = r.banners
    })
  },
  methods: {
    formatMoney,
    validatePassword,
    validateUsername,
    unitConversion,
    ...mapActions(useUserStore, {
      usernameSms: 'usernameSms',
      restPwd: 'restPwd',
      checkBindViaUser: 'checkBindViaUser',
      logout: 'logout'
    }),
    ...mapActions(useLobbyStore, {
      favorite: 'favorite',
      updatecollectGameId: 'updatecollectGameId',
      popup: 'popup',
      hidePopup: 'hidePopup',
      getBannersHomeTop: 'getBannersHomeTop',
      enterGame: 'enterGame',
      hideStickyBanners: 'hideStickyBanners',
      hideDownloadAppBanner: 'hideDownloadAppBanner'
    }),
    ...mapActions(useEnvelopeStore, { envelope: 'envelope' }),
    onOpenLogin() {
      this.$bus.$emit(BUS.SHOW_POPUP, { from: 'userBar', to: POPUP.LOGIN, show: true })
    },
    onOpenRegister() {
      this.$bus.$emit(BUS.SHOW_POPUP, { from: 'userBar', to: POPUP.REGISTER, show: true })
    },
    onShowMenu() {
      this.$bus.$emit(BUS.SHOW_MENU, true)
    },
    onDownLoadAPk() {
      downloadAPK(this.country)
    },
    onDeposit() {
      if (this.country == 'CI') {
        this.$router.replace('/depositci')
      } else if (this.country == 'KE') {
        this.$router.replace('/depositke')
      } else if (this.country == 'TZ') {
        this.$router.replace('/deposittz')
      } else if (this.country == 'GH') {
        this.$router.replace('/depositgh')
      } else {
        this.$router.replace('/deposit')
      }
    },
    showBalanceInfo() {
      this.balanceWidth = this.$refs.balanceRef.clientWidth - 25
      this.showBalanceTips = !this.showBalanceTips
    },
    onClickBanner(banner) {
      if (banner.cmd == 'game') {
        if (this.isLogin) {
          this.enterGame(parseInt(banner.cmdValue)).then((response) => {
            this.$router.push({ name: 'gameView', params: { currentGameUrl: response.url } })
          })
        } else {
          this.$bus.$emit(BUS.SHOW_POPUP, { from: 'gridListGame', to: POPUP.LOGIN, show: true })
        }
      } else if (banner && banner.cmd == 'h5') {
        window.location.href = banner.cmdValue
      } else if (banner && banner.cmd == 'deeplink') {
        this.$router.replace(`/${banner.cmdValue}`)
      } else if (banner && banner.cmd == 'luckywheel') {
        if (!this.isLogin) {
          this.$bus.$emit(BUS.SHOW_POPUP, { from: 'banner', to: POPUP.LOGIN, show: true })
          return
        }
        const url = `${banner.cmdValue}?token=${encodeBase64(getLocalStorage(Key.Token))}`
        this.$router.push({ name: 'gameView', params: { currentGameUrl: url } })
      } else if (banner && banner.cmd == 'active') {
        if (banner.cmdValue == 'redenvelope') {
          enterEnvelop(this.isLogin)
        }
      }
      this.hideStickyBanners()
    }
  }
}
</script>

<style lang="scss" scoped>
.app-download {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: calc(var(--user-bar-height) + 0.1rem);
  background-color: #000;
  position: fixed;
  z-index: 12;

  .download-left {
    display: flex;
    flex-direction: row;
    align-items: center;

    .download-icon {
      height: 0.6rem;
      margin-left: 0.3rem;
    }

    .download-desc {
      font-size: 0.24rem;
      text-align: left;
      width: auto;
      margin-left: 0.3rem;
      color: #ceb45f;
    }
  }

  .download-btn {
    margin-left: 0.06rem;
    padding-left: 0.27rem;
    padding-right: 0.32rem;
    height: 0.5rem;
    font-size: 0.24rem;
    line-height: 0.5rem;
    color: #fff;
    text-align: center;
    border-radius: 0.25rem;
    margin-right: 0.3rem;
    background: #825c2d;
    background: linear-gradient(145deg, #ceb45f 5%, #825c2d, #ceb45f 50%, #825c2d, #ceb45f 95%);
    background-size: 300% 300%;
    animation: gradientBG 2s linear infinite;
  }
}

.sticky_banner {
  position: fixed;
  z-index: 12;
  top: 0;
  width: 100%;
  height: 5.55vw;
  background-color: #000;

  .swiper {
    height: 100%;

    .item {
      height: 100%;
      background-repeat: no-repeat;
      background-size: 100vw 5.55vw;
    }
  }
}

.top_0 {
  top: 0;
}

.top_1 {
  top: 5.55vw;
}

.user-bar {
  position: fixed;
  z-index: 12;

  width: 100%;
  height: var(--user-bar-height);
  background-color: #000;
  box-sizing: border-box;
  padding: 0 0.2rem;

  .left {
    color: white;

    i {
      font-size: 0.6rem;
      color: #fff;
      cursor: pointer;
    }

    img {
      margin: 0.2rem;
      // width: 1.2rem;
      height: 0.6rem;
    }
  }

  .right {
    font-size: 0.24rem;
    color: #ceb45f;

    .wallet {
      height: 0.5rem;
      border-radius: 0.1rem;
      background: linear-gradient(145deg, #ceb45f 5%, #825c2d 70%);
      padding: 0 0.19rem;
      cursor: pointer;

      .balance {
        min-width: 1rem;
        font-size: 0.3rem;
        line-height: 1;
        color: #fff;
      }

      .slicer {
        background: #000;
        height: 100%;
        width: 0.02rem;
        margin: 0 0.2rem;
      }

      i {
        font-size: 0.2rem;
        color: #fff;
      }
    }

    .login {
      font-size: 0.24rem;
      line-height: 0.5rem;
      color: #ceb45f;
      text-align: center;
      display: block;
      padding-left: 0.32rem;
      padding-right: 0.27rem;
      height: 0.5rem;
      float: left;
      border-radius: 0.25rem 0 0 0.25rem;
      border: 0.02rem solid #ceb45f;
      cursor: pointer;
      box-sizing: border-box;
    }

    .register {
      margin-left: 0.06rem;
      padding-left: 0.27rem;
      padding-right: 0.32rem;
      height: 0.5rem;
      font-size: 0.24rem;
      line-height: 0.5rem;
      color: #fff;
      text-align: center;
      border-radius: 0 0.25rem 0.25rem 0;
      // background: linear-gradient(145deg, #ceb45f 5%, #825c2d 70%);
      // cursor: pointer;
      // box-sizing: border-box;
      background: #825c2d;
      background: linear-gradient(145deg, #ceb45f 5%, #825c2d, #ceb45f 50%, #825c2d, #ceb45f 95%);
      background-size: 300% 300%;
      animation: gradientBG 2s linear infinite;
    }
  }
}

.balance-tips {
  position: absolute;
  top: 0.7rem;
  right: 0.25rem;
  padding: 0 0.2rem;
  background-color: #000;
  border-radius: 0.15rem;

  p {
    font-size: 0.3rem;
    color: #fff;
    line-height: 0.1rem;
  }
}

.close_center {
  display: flex !important;
  margin-top: -0.5rem !important;
  justify-content: center;
  align-items: flex-start;
}

.popup_close {
  height: 0.8rem;
  width: 0.8rem;
  border-radius: 50%;
  background-color: #000;
  border: solid 4px transparent;
  background-image: linear-gradient(#000, #000),
    linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
  background-origin: border-box;
  background-clip: content-box, border-box;
  margin-top: -1.2rem;
  text-align: center;
  position: absolute;
  display: block;
  z-index: 2;
  margin-left: 90%;

  span {
    display: inline-block;
    width: 0.6rem;
    height: 0.08rem;
    background-color: #aa884a;
    background-image: linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
    transform: rotate(45deg);
    margin-top: 0.355rem;
  }

  span::after {
    content: '';
    display: block;
    width: 0.6rem;
    height: 0.08rem;
    background-color: #aa884a;
    background-image: linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
    transform: rotate(-90deg);
  }
}

.register-dialog {
  height: 9.5rem;
  overflow: visible !important;

  .default {
    padding: 0 0.37rem;

    .banner {
      width: 5.4rem;
      height: 1.29rem;
      border-radius: 0.2rem;
      margin-bottom: 0.39rem;
    }

    //form {
    //  margin: 0 !important;
    //  padding: 0 !important;
    //}

    .submit {
      width: 100%;
      height: var(--input-height);
      border-radius: 0.44rem;
      background: #aa884a;
      line-height: var(--input-height);
      font-weight: 400;
      font-size: 0.3rem;
      color: #ffffff;
      text-align: center;

      &:active {
        background: #98aa4a;
      }
    }

    .sign-in {
      width: 100%;
      margin-top: 0.34rem;
      font-weight: 400;
      font-size: 0.3rem;
      color: #ffddac;
      text-decoration-line: underline;
      cursor: pointer;
      text-align: right;
    }

    .sign-up {
      margin: 0.36rem 0;
      width: 100%;
      font-weight: 400;
      font-size: 0.23rem;
      color: #ffffff;
      text-align: right;
    }

    .forget {
      margin-bottom: 0.36rem;
      width: 100%;
      font-weight: 400;
      font-size: 0.23rem;
      color: #ffddac;
      text-decoration-line: underline;
      cursor: pointer;
      text-align: right;
    }

    .desc {
      margin-top: 0.59rem;
      margin-bottom: 0.15rem;
      font-weight: 400;
      font-size: 0.23rem;
      // color: #95a5a5;
      color: #ffffff;
      text-align: center;
    }
  }

  .footer {
    height: 1rem;
    // background: #2d3e50;

    font-weight: 400;
    font-size: 0.3rem;
    text-align: center;
    line-height: 1rem;
    color: #ffdeab;
    text-decoration-line: underline;
  }
}

.popup_box {
  width: 6.5rem;
  height: auto;
  margin: 0 auto;
  padding: 0 !important;
  overflow: visible !important;
  border: solid 0.04rem transparent;
  border-radius: 0.16rem;
  background-color: #000;
  background-image: linear-gradient(#000, #000),
    linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
  background-origin: border-box;
  background-clip: content-box, border-box;
  text-align: center;
  // overflow: hidden;

  .popup {
    width: 90%;
    height: auto;
    border-radius: 12px;
    display: block;
    padding: 5% 5% 5% 5%;
    margin: 0 auto;

    h1 {
      font-size: 0.3rem;
      line-height: 0.4rem;
      margin: 0.1rem 0;
      font-weight: normal;
    }

    h2 {
      font-size: 0.24rem;
      line-height: 0.3rem;
      margin: 0.1rem 0;
      font-weight: normal;
    }

    p {
      line-height: 0.32rem;
      margin: 0;
      color: #fff;
    }

    .popup_nation {
      width: 100%;
      overflow: hidden;

      li {
        float: left;
        width: 93.4%;
        border-radius: 0.16rem;
        display: inline-block;
        line-height: 0.5rem;
        border: 2px solid #aa884a;
        padding: 3%;
        margin: 0.15rem 0;

        P {
          float: left;
          color: #aa884a;
          font-size: 0.24rem;
          margin-left: 0.2rem;
          line-height: 0.75rem;
          display: inline-block;
        }

        img {
          border-radius: 0.16rem;
          float: left;
          width: 25%;
        }

        i {
          float: right;
          font-size: 0.75rem;
          color: #ffddac;
          display: none;
        }
      }
    }

    .popup_nation_active {
      border: 2px solid #ffddac !important;
      box-shadow:
        inset 0 0 0.2rem #ffddac,
        inset 0 0 0.1rem #ffddac,
        inset 0 0 0.05rem #ffddac;

      p {
        color: #ffddac !important;
      }

      i {
        color: #ffddac !important;
        display: block !important;
      }
    }

    .steps {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0.8rem 0;

      .step {
        flex-basis: 50%;
      }

      .step-head {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
      }

      .step:last-of-type .step-head .line {
        display: none;
      }

      .active-icon {
        color: #fff !important;
        background-color: #aa884a !important;
      }

      .icon {
        font-size: 0.3rem;
        line-height: 0.6rem;
        font-weight: bold;
        color: #95a5a5;
        text-align: center;
        position: absolute;
        width: 0.6rem;
        height: 0.6rem;
        background-color: #324559;
        border-radius: 50%;
        z-index: 1;
      }

      .line {
        position: absolute;
        right: -50%;
        left: 50%;
        width: 100%;
        height: 0.1rem;
        background-color: #aa884a;
        z-index: 0;
      }

      .active-line {
        background-color: #324559 !important;
      }
    }

    .code_digit {
      margin: 0.2rem 0;
      padding: 0;
      width: 100%;
      overflow: hidden;

      li {
        line-height: 0.7rem;
        background-color: #ffddac;
        display: inline-block;
        border-radius: 0.16rem;
        float: left;
        width: 14%;
        height: 0.7rem;
        margin: 0 1.33%;
        padding: 0;
        text-align: center;
        color: black;
        font-size: 0.48rem;
      }

      input {
        outline-style: none;
        outline-width: 0;
        border: none;
        border-style: none;
        text-shadow: none;
        -webkit-appearance: none;
        -webkit-user-select: text;
        outline-color: transparent;
        background-color: transparent;
        box-shadow: none;
        font-size: 0.48rem;
        line-height: 0.7rem;
        float: left;
        width: 94.5%;
        margin: -0.7rem 0 0 5.5%;
        padding: 0;
        position: relative;
        z-index: 2;
        letter-spacing: 0.71rem;
        overflow: hidden;
        overflow-x: hidden;
        text-align: left;
        color: rgba($color: #000000, $alpha: 0);
      }
    }

    .btn_100 {
      line-height: 0.66rem;
      text-align: center;
      border-radius: 0.33rem;
      margin: 0.4rem 0;
      font-size: 0.4rem;
    }

    .btn_yellow {
      color: #fff;
      background-color: #aa884a;
      border: 2px solid #aa884a;
    }

    .popup_footer {
      text-align: center;
      margin: 0px;
      padding: 0.3rem 0;
      height: auto;
      width: 100%;
      color: #ffddac;
      font-size: 0.38rem;

      overflow: hidden;
      text-decoration: underline;
    }
  }
}

@keyframes gradientBG {
  0% {
    background-position: 0% 50%;
  }

  100% {
    background-position: 100% 50%;
  }
}

@keyframes scaleIn {
  0% {
    scale: 0;
  }

  100% {
    scale: 1;
  }
}
</style>
